import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserRoles } from '~/components/Auth';
import { Roles } from '~/data/user';
import { hasOneOfRoles } from '~/services/Permissions';

import { ChatBotWidget } from './ChatBotWidget/component';
import { useChatUI } from './useChatUI';
import { useSxStyles } from './useStyles';

export const ChatBotDialog = () => {
  const { isOpen, close } = useChatUI();
  const userRoles = useLoggedInUserRoles();

  const { t } = useTranslation();
  const sx = useSxStyles();

  const isHrUser = hasOneOfRoles(userRoles, [
    Roles.HR_ADMIN,
    Roles.HR_ADMIN_LIMITED,
    Roles.HR_STAFF,
    Roles.HR_DEV,
  ]);

  if (!isOpen || !isHrUser) return null;

  return (
    <Box sx={sx.root} onClick={(e) => e.stopPropagation()}>
      <Box sx={sx.container}>
        <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#111' }}>
          {t('solAIris')}
        </Typography>

        <IconButton size="small" onClick={close} title="Close">
          <Close fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0 }}>
        <ChatBotWidget hideTopHeader />
      </Box>
    </Box>
  );
};
